import { AppButton } from 'client/ui-building-blocks'
import { usePage } from 'client/hooks'

const GenericError = () => {
  const { navigateTo } = usePage()

  const onHomePageBtnClick = () => {
    navigateTo({ path: '/home' })
  }

  return <AppButton text="Home page" position="center" onClick={onHomePageBtnClick} />
}

export default GenericError
